module.exports = __webpack_public_path__ + "static/medium-65307fbbc0d3435f76472f78d72fb97a.png";